import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from './lib/queries.js';
import { routeTree } from './routeTree.gen';
import '@suvoda-uat/ui-suvoda/styles/global.css';

// The router type augmentation lives in `router.d.ts` — kept separate
// so `interface` declaration merging (the canonical TanStack pattern)
// can survive ESLint's auto-fix without polluting this entry point.
export const router = createRouter({ routeTree });

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
